// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

//引入vuex
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    tab: 'first',
    tabStatus: 0,
    tab2Status: 0,
  },
  mutations: {
    setTab (state, data) {
      state.tab = data;
    },
    setTabStatus (state, data) {
      state.tabStatus = data;
    },
    setTab2Status (state, data) {
      state.tab2Status = data;
    },
  }
})

import VueAwesomeSwiper from 'vue-awesome-swiper'//  全局渲染
import 'swiper/css/swiper.css'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import App from './App'
import router from './router'
import axios from 'axios'
import Api from './util/Api.js'
// import wxApi from './util/wxapi.js'
import common from '../static/js/common.js'

//复制到粘贴板插件
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
// 复制到粘贴板插件***********end

// 使用LESS
import less from 'less'
Vue.use(less)

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.prototype.common=common
Vue.prototype.$axios = axios
// Vue.prototype.$wxApi = wxApi

// Vue.use(ElementUI)
// 基础组件的自动化全局注册
// const requireComponent=require.context()
//按需引入element（）
import {InfiniteScroll,Dialog,MessageBox,Button, Select,Input,Tabs,TabPane,Option,Row,Col,Card,Container,Header,Main,Footer,Radio,Drawer,Message,Loading,PageHeader,Upload } from 'element-ui';
Vue.use(Button)
Vue.use(Dialog)
Vue.use(InfiniteScroll)
Vue.use(PageHeader)
Vue.use(Select)
Vue.use(Input)
Vue.use(Tabs)
Vue.use(Drawer)
Vue.use(TabPane)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Container)
Vue.use(Header)
Vue.use(Footer)
Vue.use(Main)
Vue.use(Radio)
Vue.use(Upload)
Vue.use(Api)
Vue.use(Loading.directive)

let user_agent = window.navigator.userAgent.toLowerCase();
let client = '';
if (user_agent.match(/magapp/i) == 'magapp') {
  client = 'magapp';
} else if (user_agent.match(/micromessenger/i) == 'micromessenger') {
  client = 'wxh5';
} else {
  client = 'h5';
}

Vue.prototype.$client = client;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$upload = Upload;

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  components: { App },
  template: '<App/>',
  render:h=>h(App)
})



// WEBPACK FOOTER //
// ./src/main.js